{
  "familyId": "GET-PROC-BTW",
  "questions": [
    {
      "id": "GET-PROC-BTW-001",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een boekhouder controleert een factuur. Het totaalbedrag is €121 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€100", "€95,59", "€96", "€101,21"],
      "correctAnswer": 0,
      "conceptId": "vat_exclusive_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW exclusief berekenen",
            "content": "Prijs inclusief BTW = prijs exclusief × 1,21 (bij 21% BTW). Dus: prijs exclusief = prijs inclusief ÷ 1,21. Voorbeeld: €121 ÷ 1,21 = €100.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De boekhouder moet de prijs exclusief BTW vinden. Inclusief 21% BTW betekent: prijs exclusief × 1,21 = €121. Dus prijs exclusief = €121 ÷ 1,21 = €100. Controleer: €100 × 1,21 = €121 ✓.",
        "solutionSteps": [
          "Inclusief BTW = exclusief × 1,21",
          "Dus exclusief = inclusief ÷ 1,21",
          "€121 ÷ 1,21 = €100",
          "Controleer: €100 × 1,21 = €121 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €121 ÷ 1,21 = €100. De boekhouder deelt het totaalbedrag door 1,21.",
          "1": "Je dacht waarschijnlijk dat je 21% van €121 moet aftrekken: €121 − €25,41 = €95,59. Maar 21% BTW is berekend over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,21, niet aftrekken.",
          "2": "Je dacht waarschijnlijk dat je €121 − €25 = €96 kunt rekenen. Maar de BTW is geen vast bedrag van €25. Onthoud: deel door 1,21 om de prijs exclusief te vinden.",
          "3": "Je dacht waarschijnlijk dat je €100 + €1,21 = €101,21 moet rekenen. Maar de BTW is al in €121 inbegrepen. Onthoud: bij 'inclusief BTW' zit de BTW er al in."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-002",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een ondernemer koopt kantoorspullen voor €60,50 inclusief 21% BTW. Hoeveel is het BTW-bedrag?",
      "options": ["€10,50", "€12,71", "€50", "€21"],
      "correctAnswer": 0,
      "conceptId": "vat_amount_calculation",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW-bedrag berekenen",
            "content": "Stap 1: prijs exclusief = €60,50 ÷ 1,21 = €50. Stap 2: BTW = inclusief − exclusief = €60,50 − €50 = €10,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De ondernemer wil weten hoeveel BTW er in de prijs zit. Stap 1: prijs exclusief BTW = €60,50 ÷ 1,21 = €50. Stap 2: BTW = €60,50 − €50 = €10,50.",
        "solutionSteps": [
          "Prijs exclusief = €60,50 ÷ 1,21 = €50",
          "BTW-bedrag = inclusief − exclusief",
          "BTW = €60,50 − €50 = €10,50",
          "Of: BTW = €50 × 0,21 = €10,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €60,50 ÷ 1,21 = €50. BTW = €60,50 − €50 = €10,50.",
          "1": "Je dacht waarschijnlijk dat je 21% van €60,50 berekent: €60,50 × 0,21 = €12,71. Maar 21% BTW is over de prijs exclusief, niet over de prijs inclusief. Onthoud: eerst delen door 1,21, dan het verschil berekenen.",
          "2": "Je verwart de prijs exclusief BTW met het BTW-bedrag. €50 is de prijs exclusief BTW, niet het BTW-bedrag. Onthoud: BTW = inclusief − exclusief = €60,50 − €50 = €10,50.",
          "3": "Je dacht waarschijnlijk dat het BTW-percentage gelijk is aan het BTW-bedrag. Maar 21% is een percentage, geen bedrag in euro's. Onthoud: BTW = prijs exclusief × 0,21."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-003",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een accountant controleert een factuur van €242 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€200", "€191,18", "€221", "€263"],
      "correctAnswer": 0,
      "conceptId": "vat_exclusive_invoice",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW exclusief berekenen",
            "content": "Prijs exclusief = prijs inclusief ÷ 1,21. €242 ÷ 1,21 = €200. Controleer: €200 × 1,21 = €242 ✓.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De accountant deelt het totaalbedrag door 1,21: €242 ÷ 1,21 = €200. Controleer: €200 × 1,21 = €242 ✓.",
        "solutionSteps": [
          "Exclusief = inclusief ÷ 1,21",
          "€242 ÷ 1,21 = €200",
          "Controleer: €200 × 1,21 = €242 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €242 ÷ 1,21 = €200.",
          "1": "Je dacht waarschijnlijk dat je 21% van €242 aftrekt: €242 − €50,82 = €191,18. Maar 21% BTW is over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,21.",
          "2": "Je dacht waarschijnlijk dat je €242 − €21 = €221 kunt rekenen. Maar €21 is het percentage, niet het BTW-bedrag. Onthoud: deel door 1,21 om de prijs exclusief te vinden.",
          "3": "Je dacht waarschijnlijk dat je 21% moet optellen. Maar de BTW zit er al in bij 'inclusief'. Onthoud: bij inclusief BTW deel je door 1,21, je telt niet op."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-004",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een zzp'er stuurt een offerte. De prijs exclusief BTW is €350. Hoeveel betaalt de klant inclusief 21% BTW?",
      "options": ["€423,50", "€371", "€421", "€350,21"],
      "correctAnswer": 0,
      "conceptId": "vat_inclusive_from_exclusive",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.77,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijs inclusief BTW berekenen",
            "content": "Prijs inclusief = prijs exclusief × 1,21. €350 × 1,21 = €423,50. Of: BTW = €350 × 0,21 = €73,50, totaal = €350 + €73,50 = €423,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De zzp'er berekent de prijs inclusief BTW: €350 × 1,21 = €423,50. Of stap voor stap: BTW = €350 × 0,21 = €73,50. Totaal = €350 + €73,50 = €423,50.",
        "solutionSteps": [
          "Prijs exclusief = €350",
          "BTW = €350 × 0,21 = €73,50",
          "Prijs inclusief = €350 + €73,50 = €423,50",
          "Of sneller: €350 × 1,21 = €423,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €350 × 1,21 = €423,50.",
          "1": "Je dacht waarschijnlijk dat je €350 + €21 = €371 kunt rekenen. Maar €21 is het percentage, niet het BTW-bedrag. Onthoud: BTW = €350 × 0,21 = €73,50.",
          "2": "Je dacht waarschijnlijk dat de BTW €71 is. Maar 21% van €350 = €73,50, niet €71. Onthoud: vermenigvuldig met 0,21, niet met 0,20.",
          "3": "Je dacht waarschijnlijk dat je €0,21 bij de prijs optelt. Maar 21% is een percentage, geen bedrag in euro's. Onthoud: 21% = 0,21 × de prijs."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-005",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een winkelier verkoopt een product voor €54,45 inclusief 9% BTW. Wat is de prijs exclusief BTW?",
      "options": ["€49,95", "€49,55", "€45,45", "€59,35"],
      "correctAnswer": 0,
      "conceptId": "vat_exclusive_9pct",
      "variantIndex": 5,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW exclusief berekenen (9%)",
            "content": "Bij 9% BTW deel je door 1,09. €54,45 ÷ 1,09 = €49,95. Controleer: €49,95 × 1,09 ≈ €54,45 ✓.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De winkelier deelt door 1,09 (want 9% BTW): €54,45 ÷ 1,09 = €49,95. Controleer: €49,95 × 1,09 ≈ €54,45 ✓. Let op: bij 9% BTW deel je door 1,09, niet door 1,21!",
        "solutionSteps": [
          "9% BTW → deel door 1,09",
          "€54,45 ÷ 1,09 = €49,95",
          "Controleer: €49,95 × 1,09 ≈ €54,45 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €54,45 ÷ 1,09 = €49,95.",
          "1": "Je dacht waarschijnlijk dat je 9% van €54,45 aftrekt: €54,45 − €4,90 = €49,55. Maar 9% BTW is over de prijs exclusief, niet over de prijs inclusief. Onthoud: deel door 1,09.",
          "2": "Je dacht waarschijnlijk dat je €54,45 − €9 = €45,45 kunt rekenen. Maar €9 is het percentage, niet het BTW-bedrag. Onthoud: deel door 1,09.",
          "3": "Je dacht waarschijnlijk dat je 9% moet optellen. Maar de BTW zit er al in bij 'inclusief'. Onthoud: bij inclusief BTW deel je, je telt niet op."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-006",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een loodgieter stuurt een rekening van €302,50 inclusief 21% BTW. Hoeveel BTW heeft de klant betaald?",
      "options": ["€52,50", "€63,53", "€250", "€302,50"],
      "correctAnswer": 0,
      "conceptId": "vat_amount_from_inclusive",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW-bedrag uit inclusief prijs",
            "content": "Stap 1: prijs exclusief = €302,50 ÷ 1,21 = €250. Stap 2: BTW = €302,50 − €250 = €52,50.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De klant wil weten hoeveel BTW er in de rekening van de loodgieter zit. Stap 1: prijs exclusief = €302,50 ÷ 1,21 = €250. Stap 2: BTW = €302,50 − €250 = €52,50.",
        "solutionSteps": [
          "Prijs exclusief = €302,50 ÷ 1,21 = €250",
          "BTW = inclusief − exclusief",
          "BTW = €302,50 − €250 = €52,50",
          "Of: BTW = €250 × 0,21 = €52,50 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €302,50 ÷ 1,21 = €250. BTW = €302,50 − €250 = €52,50.",
          "1": "Je dacht waarschijnlijk dat je 21% van €302,50 berekent: €302,50 × 0,21 = €63,53. Maar 21% BTW is over de prijs exclusief (€250), niet over de prijs inclusief. Onthoud: eerst delen door 1,21.",
          "2": "Je verwart de prijs exclusief BTW met het BTW-bedrag. €250 is de prijs exclusief, niet de BTW. Onthoud: BTW = inclusief − exclusief.",
          "3": "Je dacht waarschijnlijk dat het hele bedrag BTW is. Maar €302,50 is de totaalprijs inclusief BTW. De BTW is slechts een deel daarvan: €52,50."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-007",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een webdesigner rekent €75 per uur exclusief BTW. Ze werkt 8 uur. Hoeveel betaalt de klant inclusief 21% BTW?",
      "options": ["€726", "€621", "€600", "€675"],
      "correctAnswer": 0,
      "conceptId": "vat_multi_step",
      "variantIndex": 7,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.68,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW berekenen in twee stappen",
            "content": "Stap 1: totaal exclusief = uurprijs × uren = €75 × 8 = €600. Stap 2: inclusief BTW = €600 × 1,21 = €726.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Eerst berekent de webdesigner het totaal exclusief BTW: €75 × 8 = €600. Dan berekent ze de prijs inclusief BTW: €600 × 1,21 = €726.",
        "solutionSteps": [
          "Totaal exclusief = €75 × 8 = €600",
          "Inclusief BTW = €600 × 1,21 = €726",
          "Of: BTW = €600 × 0,21 = €126, totaal = €600 + €126 = €726 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! €75 × 8 = €600, en €600 × 1,21 = €726.",
          "1": "Je dacht waarschijnlijk dat je €75 × 1,21 = €90,75 per uur rekent, en dan × 8 = €621... maar dat klopt niet. €75 × 1,21 = €90,75, en €90,75 × 8 = €726. Je hebt waarschijnlijk een rekenfout gemaakt. Onthoud: de volgorde maakt niet uit, het antwoord is €726.",
          "2": "Je dacht waarschijnlijk dat €600 het eindantwoord is. Maar €600 is de prijs exclusief BTW. De klant betaalt inclusief BTW: €600 × 1,21 = €726. Onthoud: de klant betaalt altijd inclusief BTW.",
          "3": "Je dacht waarschijnlijk dat je €75 + BTW per uur rekent en dan × 8. Maar €75 is het uurtarief exclusief BTW. De BTW over 8 uur is: €600 × 0,21 = €126, niet €75. Onthoud: bereken eerst het totaal exclusief, dan de BTW."
        }
      }
    },
    {
      "id": "GET-PROC-BTW-008",
      "familyId": "GET-PROC-BTW",
      "module": "Getalbegrip",
      "tier": 16,
      "levelCode": "E8+",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_btw_excl",
      "questionType": "multiple_choice",
      "question": "Een kapper betaalt €1.089 inclusief 21% BTW voor nieuwe apparatuur. Hoeveel kan de kapper aftrekken als BTW?",
      "options": ["€189", "€228,69", "€900", "€1.089"],
      "correctAnswer": 0,
      "conceptId": "vat_deduction",
      "variantIndex": 8,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.69,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "BTW aftrekken",
            "content": "Ondernemers mogen de BTW aftrekken. Stap 1: prijs exclusief = €1.089 ÷ 1,21 = €900. Stap 2: BTW = €1.089 − €900 = €189.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De kapper kan de BTW aftrekken. Stap 1: prijs exclusief = €1.089 ÷ 1,21 = €900. Stap 2: BTW = €1.089 − €900 = €189. De kapper kan €189 aftrekken.",
        "solutionSteps": [
          "Prijs exclusief = €1.089 ÷ 1,21 = €900",
          "BTW = inclusief − exclusief",
          "BTW = €1.089 − €900 = €189",
          "De kapper kan €189 aftrekken ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Exclusief = €1.089 ÷ 1,21 = €900. BTW = €1.089 − €900 = €189.",
          "1": "Je dacht waarschijnlijk dat je 21% van €1.089 berekent: €1.089 × 0,21 = €228,69. Maar 21% BTW is over de prijs exclusief (€900), niet over de prijs inclusief. Onthoud: eerst delen door 1,21.",
          "2": "Je verwart de prijs exclusief BTW met het BTW-bedrag. €900 is de prijs exclusief, niet de BTW. De BTW is €1.089 − €900 = €189.",
          "3": "Je dacht waarschijnlijk dat het hele bedrag als BTW afgetrokken kan worden. Maar €1.089 is de totaalprijs. Alleen de BTW (€189) kan worden afgetrokken."
        }
      }
    }
  ]
}